export const appConfig = {
  app: {
    name: 'NanoImage2',
    nameEn: 'NanoImage2',
    version: '2.0.0',
    slogan: '输入一句话，立即生成图片',
    newUserGift: {
      points: 6,
      desc: '注册即送 6 积分，可生成 3 张图片',
    },
  },

  user: {
    userId: 'u_001',
    nickname: '创作者小明',
    avatar: 'https://readdy.ai/api/search-image?query=minimalist%20elegant%20human%20silhouette%20portrait%20avatar%2C%20soft%20warm%20gradient%20lighting%2C%20neutral%20beige%20and%20soft%20cream%20tones%2C%20abstract%20artistic%20style%2C%20clean%20simple%20background%2C%20subtle%20shadow%2C%20modern%20flat%20design%20aesthetic&width=80&height=80&seq=avatar2&orientation=squarish',
    phone: '138****8888',
    points: 86,
    isVip: true,
    vipExpireTime: '2026-05-26',
    generateCount: 6,
  },

  points: {
    rules: [
      { action: 'register', label: '注册奖励', value: '+6', icon: 'ri-user-add-line' },
      { action: 'dailyLogin', label: '每日登录', value: '+1', icon: 'ri-calendar-check-line' },
      { action: 'generate', label: '每次生图', value: '-2', icon: 'ri-sparkling-2-line' },
    ],
    aiHelpLimit: {
      freePerDay: 1,
      vipUnlimited: true,
    },
  },

  pointsLog: [
    { id: 'pl_001', type: 'consume', desc: 'AI 生图消耗', points: -2, createdAt: '2026-04-23 14:32' },
    { id: 'pl_002', type: 'consume', desc: 'AI 生图消耗', points: -2, createdAt: '2026-04-23 11:15' },
    { id: 'pl_003', type: 'earn', desc: '每日登录奖励', points: 1, createdAt: '2026-04-23 09:00' },
    { id: 'pl_004', type: 'consume', desc: 'AI 生图消耗', points: -2, createdAt: '2026-04-22 20:08' },
    { id: 'pl_005', type: 'consume', desc: 'AI 生图消耗', points: -2, createdAt: '2026-04-22 16:44' },
    { id: 'pl_006', type: 'earn', desc: '每日登录奖励', points: 1, createdAt: '2026-04-22 09:00' },
    { id: 'pl_007', type: 'consume', desc: 'AI 生图消耗', points: -2, createdAt: '2026-04-21 09:20' },
    { id: 'pl_008', type: 'earn', desc: '新用户注册奖励', points: 6, createdAt: '2026-04-20 10:00' },
  ],

  templates: [
    {
      id: 't_female_clean',
      category: 'female_portrait',
      name: '清纯写真',
      nameKey: 'tpl_t_female_clean',
      cover: 'https://readdy.ai/api/search-image?query=beautiful%20young%20asian%20woman%20portrait%20photography%2C%20soft%20pink%20background%2C%20professional%20studio%20lighting%2C%20elegant%20pose%2C%20high%20quality%20fashion%20photo%2C%20natural%20makeup&width=200&height=280&seq=tpl1&orientation=portrait',
      defaultPrompt: '一位美丽的年轻女性，精致妆容，柔和自然光，时尚写真风格，高清细节',
      recommendStyleId: 's_film',
      recommendRatio: '3:4',
    },
    {
      id: 't_female_outdoor',
      category: 'female_portrait',
      name: '户外写真',
      nameKey: 'tpl_t_female_outdoor',
      cover: 'https://readdy.ai/api/search-image?query=beautiful%20young%20asian%20woman%20outdoor%20portrait%20photography%2C%20golden%20hour%20sunlight%2C%20natural%20park%20scenery%20background%2C%20casual%20fashion%20style%2C%20warm%20tones%2C%20high%20quality%20photo&width=200&height=280&seq=tpl6&orientation=portrait',
      defaultPrompt: '美丽女生户外写真，金色阳光，自然背景，休闲时尚，暖色调，高清细节',
      recommendStyleId: 's_film',
      recommendRatio: '3:4',
    },
    {
      id: 't_female_fashion',
      category: 'female_portrait',
      name: '时尚大片',
      nameKey: 'tpl_t_female_fashion',
      cover: 'https://readdy.ai/api/search-image?query=asian%20fashion%20model%20portrait%2C%20high%20fashion%20editorial%20style%2C%20dramatic%20studio%20lighting%2C%20luxury%20clothing%2C%20magazine%20cover%20quality%2C%20bold%20makeup%2C%20professional%20photography&width=200&height=280&seq=tpl7&orientation=portrait',
      defaultPrompt: '时尚杂志大片风格，高级感妆容，戏剧性光影，奢华服装，专业棚拍质感',
      recommendStyleId: 's_ccd',
      recommendRatio: '3:4',
    },
    {
      id: 't_female_sweet',
      category: 'female_portrait',
      name: '甜美日系',
      nameKey: 'tpl_t_female_sweet',
      cover: 'https://readdy.ai/api/search-image?query=cute%20sweet%20japanese%20style%20girl%20portrait%2C%20soft%20pastel%20colors%2C%20cherry%20blossom%20background%2C%20innocent%20smile%2C%20kawaii%20fashion%2C%20film%20camera%20aesthetic%2C%20dreamy%20atmosphere&width=200&height=280&seq=tpl8&orientation=portrait',
      defaultPrompt: '甜美日系少女写真，粉嫩色调，樱花背景，清纯笑容，胶片质感',
      recommendStyleId: 's_film',
      recommendRatio: '3:4',
    },
    {
      id: 't_male_portrait',
      category: 'male_portrait',
      name: '帅气写真',
      nameKey: 'tpl_t_male_portrait',
      cover: 'https://readdy.ai/api/search-image?query=handsome%20young%20asian%20man%20portrait%20photography%2C%20clean%20white%20background%2C%20professional%20studio%20lighting%2C%20confident%20pose%2C%20high%20quality%20fashion%20photo&width=200&height=280&seq=tpl2&orientation=portrait',
      defaultPrompt: '一位帅气的年轻男性，干净利落，自然光线，时尚写真风格，高清细节',
      recommendStyleId: 's_ccd',
      recommendRatio: '3:4',
    },
    {
      id: 't_male_street',
      category: 'male_portrait',
      name: '街拍风格',
      nameKey: 'tpl_t_male_street',
      cover: 'https://readdy.ai/api/search-image?query=handsome%20young%20asian%20man%20street%20photography%2C%20urban%20city%20background%2C%20casual%20streetwear%20fashion%2C%20natural%20light%2C%20cool%20confident%20pose%2C%20high%20quality%20photo&width=200&height=280&seq=tpl9&orientation=portrait',
      defaultPrompt: '帅气男生城市街拍，都市背景，休闲潮流穿搭，自然光，酷帅姿态',
      recommendStyleId: 's_ccd',
      recommendRatio: '3:4',
    },
    {
      id: 't_male_business',
      category: 'male_portrait',
      name: '商务精英',
      nameKey: 'tpl_t_male_business',
      cover: 'https://readdy.ai/api/search-image?query=professional%20asian%20businessman%20portrait%2C%20formal%20suit%2C%20office%20background%2C%20confident%20expression%2C%20sharp%20lighting%2C%20executive%20style%2C%20high%20quality%20photography&width=200&height=280&seq=tpl10&orientation=portrait',
      defaultPrompt: '商务精英男士写真，正装西服，自信表情，专业棚拍，高级质感',
      recommendStyleId: 's_film',
      recommendRatio: '3:4',
    },
    {
      id: 't_anime_avatar',
      category: 'anime_avatar',
      name: '萌系头像',
      nameKey: 'tpl_t_anime_avatar',
      cover: 'https://readdy.ai/api/search-image?query=cute%20anime%20girl%20avatar%20illustration%2C%20pastel%20colors%2C%20big%20eyes%2C%20kawaii%20style%2C%20clean%20white%20background%2C%20digital%20art&width=200&height=280&seq=tpl3&orientation=portrait',
      defaultPrompt: '可爱动漫风格头像，大眼睛，精致五官，清新配色，二次元风格',
      recommendStyleId: 's_3d_cartoon',
      recommendRatio: '1:1',
    },
    {
      id: 't_anime_cool',
      category: 'anime_avatar',
      name: '酷炫头像',
      nameKey: 'tpl_t_anime_cool',
      cover: 'https://readdy.ai/api/search-image?query=cool%20anime%20character%20avatar%20illustration%2C%20dark%20moody%20background%2C%20glowing%20eyes%2C%20edgy%20style%2C%20detailed%20digital%20art%2C%20vibrant%20neon%20colors%2C%20dramatic%20lighting&width=200&height=280&seq=tpl11&orientation=portrait',
      defaultPrompt: '酷炫动漫风格头像，暗色背景，发光眼睛，个性风格，霓虹配色，精细数字绘画',
      recommendStyleId: 's_3d_cartoon',
      recommendRatio: '1:1',
    },
    {
      id: 't_anime_chibi',
      category: 'anime_avatar',
      name: 'Q版头像',
      nameKey: 'tpl_t_anime_chibi',
      cover: 'https://readdy.ai/api/search-image?query=chibi%20anime%20character%20illustration%2C%20super%20deformed%20cute%20style%2C%20round%20face%2C%20tiny%20body%2C%20bright%20cheerful%20colors%2C%20white%20background%2C%20japanese%20anime%20art%20style&width=200&height=280&seq=tpl12&orientation=portrait',
      defaultPrompt: 'Q版超萌动漫头像，圆脸大头，迷你身体，明亮欢快配色，日系动漫风格',
      recommendStyleId: 's_3d_cartoon',
      recommendRatio: '1:1',
    },
    {
      id: 't_chinese_portrait',
      category: 'chinese_portrait',
      name: '汉服写真',
      nameKey: 'tpl_t_chinese_portrait',
      cover: 'https://readdy.ai/api/search-image?query=beautiful%20chinese%20woman%20in%20traditional%20hanfu%20dress%2C%20ancient%20chinese%20style%20portrait%2C%20ink%20painting%20background%2C%20elegant%20pose%2C%20high%20quality&width=200&height=280&seq=tpl4&orientation=portrait',
      defaultPrompt: '古风汉服美女，精致妆容，水墨背景，国风意境，高清写真',
      recommendStyleId: 's_chinese',
      recommendRatio: '3:4',
    },
    {
      id: 't_chinese_ink',
      category: 'chinese_portrait',
      name: '水墨意境',
      nameKey: 'tpl_t_chinese_ink',
      cover: 'https://readdy.ai/api/search-image?query=chinese%20ink%20wash%20painting%20style%20portrait%2C%20misty%20mountains%20background%2C%20traditional%20chinese%20woman%2C%20flowing%20robes%2C%20poetic%20atmosphere%2C%20artistic%20brushwork%2C%20ancient%20style&width=200&height=280&seq=tpl13&orientation=portrait',
      defaultPrompt: '水墨意境人像，烟雾缭绕山水背景，古典仕女，飘逸长裙，诗意氛围',
      recommendStyleId: 's_chinese',
      recommendRatio: '3:4',
    },
    {
      id: 't_chinese_dunhuang',
      category: 'chinese_portrait',
      name: '敦煌飞天',
      nameKey: 'tpl_t_chinese_dunhuang',
      cover: 'https://readdy.ai/api/search-image?query=dunhuang%20flying%20apsaras%20style%20portrait%2C%20ancient%20chinese%20mural%20art%2C%20colorful%20flowing%20scarves%2C%20golden%20ornaments%2C%20mystical%20atmosphere%2C%20traditional%20fresco%20style%20painting&width=200&height=280&seq=tpl14&orientation=portrait',
      defaultPrompt: '敦煌飞天风格人像，古典壁画艺术，彩色飘带，金色饰品，神秘氛围',
      recommendStyleId: 's_dunhuang',
      recommendRatio: '3:4',
    },
    {
      id: 't_poster',
      category: 'poster',
      name: '渐变海报',
      nameKey: 'tpl_t_poster',
      cover: 'https://readdy.ai/api/search-image?query=modern%20creative%20poster%20design%2C%20gradient%20background%2C%20typography%2C%20minimalist%20style%2C%20professional%20graphic%20design%2C%20vibrant%20colors&width=200&height=280&seq=tpl5&orientation=portrait',
      defaultPrompt: '创意海报设计，现代简约风格，渐变背景，精美排版，视觉冲击力强',
      recommendStyleId: 's_comic',
      recommendRatio: '9:16',
    },
    {
      id: 't_poster_retro',
      category: 'poster',
      name: '复古海报',
      nameKey: 'tpl_t_poster_retro',
      cover: 'https://readdy.ai/api/search-image?query=retro%20vintage%20poster%20design%2C%20aged%20paper%20texture%2C%20classic%20typography%2C%20warm%20sepia%20tones%2C%20nostalgic%20illustration%20style%2C%20art%20deco%20elements%2C%20old%20school%20design&width=200&height=280&seq=tpl15&orientation=portrait',
      defaultPrompt: '复古风格海报，做旧纸张质感，经典排版，暖色调，怀旧插画风格，装饰艺术元素',
      recommendStyleId: 's_film',
      recommendRatio: '9:16',
    },
    {
      id: 't_poster_minimal',
      category: 'poster',
      name: '极简封面',
      nameKey: 'tpl_t_poster_minimal',
      cover: 'https://readdy.ai/api/search-image?query=minimalist%20book%20cover%20design%2C%20clean%20white%20background%2C%20simple%20geometric%20shapes%2C%20elegant%20typography%2C%20modern%20art%20style%2C%20sophisticated%20layout%2C%20premium%20design&width=200&height=280&seq=tpl16&orientation=portrait',
      defaultPrompt: '极简主义封面设计，干净白色背景，简洁几何图形，优雅排版，现代艺术风格',
      recommendStyleId: 's_comic',
      recommendRatio: '9:16',
    },
  ],

  styles: [
    {
      id: 's_ccd',
      name: 'CCD 相机',
      cover: 'https://readdy.ai/api/search-image?query=CCD%20camera%20vintage%20photo%20style%2C%20grainy%20texture%2C%20warm%20tones%2C%20nostalgic%20film%20photography%20aesthetic&width=120&height=120&seq=sty1&orientation=squarish',
      isVip: false,
      sort: 1,
      promptSuffix: ', CCD camera style, grainy texture, vintage film',
    },
    {
      id: 's_film',
      name: '胶片风',
      cover: 'https://readdy.ai/api/search-image?query=film%20photography%20style%2C%20light%20leak%20effect%2C%20vintage%20grain%2C%20analog%20film%20aesthetic%2C%20warm%20nostalgic%20tones&width=120&height=120&seq=sty2&orientation=squarish',
      isVip: false,
      sort: 2,
      promptSuffix: ', film photography style, light leak, analog grain',
    },
    {
      id: 's_chinese',
      name: '国风',
      cover: 'https://readdy.ai/api/search-image?query=traditional%20chinese%20ink%20painting%20style%2C%20ancient%20chinese%20art%2C%20elegant%20brushwork%2C%20oriental%20aesthetic&width=120&height=120&seq=sty3&orientation=squarish',
      isVip: false,
      sort: 3,
      promptSuffix: ', traditional chinese ink painting style, oriental aesthetic',
    },
    {
      id: 's_3d_cartoon',
      name: '3D 卡通',
      cover: 'https://readdy.ai/api/search-image?query=3D%20cartoon%20character%20render%2C%20cute%20chibi%20style%2C%20bright%20colors%2C%20pixar%20animation%20style%2C%20clean%20background&width=120&height=120&seq=sty4&orientation=squarish',
      isVip: false,
      sort: 4,
      promptSuffix: ', 3D cartoon render, cute chibi style, pixar animation',
    },
    {
      id: 's_comic',
      name: '漫画',
      cover: 'https://readdy.ai/api/search-image?query=manga%20comic%20style%20illustration%2C%20black%20and%20white%20line%20art%2C%20anime%20style%2C%20clean%20linework%2C%20japanese%20manga%20aesthetic&width=120&height=120&seq=sty5&orientation=squarish',
      isVip: false,
      sort: 5,
      promptSuffix: ', manga comic style, clean linework, anime illustration',
    },
    {
      id: 's_dunhuang',
      name: '敦煌壁画',
      cover: 'https://readdy.ai/api/search-image?query=dunhuang%20cave%20mural%20painting%20style%2C%20ancient%20chinese%20buddhist%20art%2C%20flying%20apsaras%2C%20rich%20colors%2C%20historical%20fresco&width=120&height=120&seq=sty6&orientation=squarish',
      isVip: true,
      sort: 6,
      promptSuffix: ', dunhuang mural painting style, ancient chinese fresco art',
    },
  ],

  ratios: [
    { id: '3:4', label: '3:4', width: 1024, height: 1365 },
    { id: '4:3', label: '4:3', width: 1365, height: 1024 },
    { id: '1:1', label: '1:1', width: 1024, height: 1024 },
    { id: '9:16', label: '9:16', width: 1024, height: 1820 },
    { id: '16:9', label: '16:9', width: 1820, height: 1024 },
  ],

  aiHelpPrompts: [
    '一位穿着白色连衣裙的年轻女性，站在樱花树下，微风轻拂，花瓣飘落，柔和的自然光，梦幻氛围，胶片摄影风格',
    '帅气男生站在城市天台，夕阳余晖，剪影效果，都市时尚感，电影级构图，暖色调',
    '可爱猫咪戴着小皇冠，坐在云朵上，周围环绕着星星和月亮，童话风格，柔和 pastel 配色',
    '未来科技感城市夜景，霓虹灯光，赛博朋克风格，高楼林立，雨夜街道，电影级画面',
  ],

  generateResults: [
    {
      id: 'g_001',
      imageUrl: 'https://readdy.ai/api/search-image?query=beautiful%20young%20asian%20woman%20portrait%2C%20soft%20natural%20lighting%2C%20elegant%20fashion%20photography%2C%20warm%20tones%2C%20professional%20studio%20quality%2C%20dreamy%20bokeh%20background%2C%20high%20resolution&width=1024&height=1365&seq=gen1&orientation=portrait',
      styleName: '胶片风',
      ratio: '3:4',
      prompt: '一位美丽的年轻女性，精致妆容，柔和自然光，时尚写真风格，高清细节',
      createdAt: '2026-04-23',
      isHd: false,
    },
    {
      id: 'g_002',
      imageUrl: 'https://readdy.ai/api/search-image?query=cute%20anime%20girl%20character%20illustration%2C%20big%20sparkling%20eyes%2C%20pastel%20pink%20and%20blue%20colors%2C%20kawaii%20style%2C%20clean%20white%20background%2C%20digital%20art%2C%20high%20quality&width=1024&height=1024&seq=gen2&orientation=squarish',
      styleName: '3D 卡通',
      ratio: '1:1',
      prompt: '可爱动漫风格头像，大眼睛，精致五官，清新配色，二次元风格',
      createdAt: '2026-04-23',
      isHd: false,
    },
    {
      id: 'g_003',
      imageUrl: 'https://readdy.ai/api/search-image?query=chinese%20woman%20in%20traditional%20hanfu%20dress%2C%20ancient%20chinese%20style%20portrait%2C%20ink%20wash%20painting%20background%2C%20elegant%20pose%2C%20soft%20lighting%2C%20high%20quality%20photography&width=1024&height=1365&seq=gen3&orientation=portrait',
      styleName: '国风',
      ratio: '3:4',
      prompt: '古风汉服美女，精致妆容，水墨背景，国风意境，高清写真',
      createdAt: '2026-04-23',
      isHd: false,
    },
    {
      id: 'g_004',
      imageUrl: 'https://readdy.ai/api/search-image?query=modern%20creative%20poster%20design%2C%20gradient%20pink%20and%20purple%20background%2C%20minimalist%20typography%2C%20professional%20graphic%20design%2C%20vibrant%20colors%2C%20clean%20layout&width=1024&height=1820&seq=gen4&orientation=portrait',
      styleName: '漫画',
      ratio: '9:16',
      prompt: '创意海报设计，现代简约风格，渐变背景，精美排版，视觉冲击力强',
      createdAt: '2026-04-23',
      isHd: false,
    },
  ],

  generateResultsText2Img: [
    {
      id: 'gt2i_001',
      imageUrl: 'https://readdy.ai/api/search-image?query=ethereal%20fantasy%20forest%20scene%20with%20glowing%20fireflies%20and%20ancient%20ruins%2C%20magical%20atmosphere%2C%20soft%20moonlight%20filtering%20through%20trees%2C%20cinematic%20composition%2C%20digital%20painting%20art%20style%2C%20rich%20colors%2C%20high%20resolution&width=1024&height=1365&seq=gt2i1&orientation=portrait',
      styleName: '文生图',
      ratio: '3:4',
      prompt: '神秘梦幻森林，萤火虫飞舞，古老遗迹，月光透过树梢，电影级构图，数字绘画风格',
      createdAt: '2026-05-24',
      isHd: false,
    },
    {
      id: 'gt2i_002',
      imageUrl: 'https://readdy.ai/api/search-image?query=futuristic%20cyberpunk%20city%20street%20at%20night%2C%20neon%20signs%20reflecting%20on%20wet%20pavement%2C%20flying%20vehicles%2C%20towering%20skyscrapers%2C%20rain%20atmosphere%2C%20highly%20detailed%20digital%20art%2C%20cinematic%20lighting&width=1024&height=1365&seq=gt2i2&orientation=portrait',
      styleName: '文生图',
      ratio: '3:4',
      prompt: '赛博朋克城市夜景，霓虹灯倒映在湿漉漉的地面，飞行车辆，摩天大楼，雨夜氛围',
      createdAt: '2026-05-24',
      isHd: false,
    },
    {
      id: 'gt2i_003',
      imageUrl: 'https://readdy.ai/api/search-image?query=cozy%20cottage%20interior%20with%20warm%20fireplace%2C%20bookshelves%2C%20cat%20sleeping%20on%20armchair%2C%20afternoon%20sunlight%20through%20window%2C%20watercolor%20illustration%20style%2C%20soft%20pastel%20colors%2C%20storybook%20atmosphere&width=1024&height=1024&seq=gt2i3&orientation=squarish',
      styleName: '文生图',
      ratio: '1:1',
      prompt: '温馨小屋室内，壁炉温暖，书架林立，猫咪睡在扶手椅上，午后阳光洒入窗户，水彩插画风格',
      createdAt: '2026-05-24',
      isHd: false,
    },
  ],

  generateResultsImg2Img: [
    {
      id: 'gi2i_001',
      imageUrl: 'https://readdy.ai/api/search-image?query=portrait%20photo%20transformed%20into%20oil%20painting%20style%2C%20visible%20brush%20strokes%2C%20rich%20impasto%20texture%2C%20classical%20art%20style%2C%20warm%20amber%20tones%2C%20museum%20quality%20artwork%2C%20dramatic%20chiaroscuro%20lighting&width=1024&height=1365&seq=gi2i1&orientation=portrait',
      styleName: '图生图',
      ratio: '3:4',
      prompt: '将参考图转换为油画风格，可见笔触，厚涂质感，古典艺术风格，暖琥珀色调，博物馆级作品',
      createdAt: '2026-05-24',
      isHd: false,
    },
    {
      id: 'gi2i_002',
      imageUrl: 'https://readdy.ai/api/search-image?query=modern%20architecture%20building%20reimagined%20in%20japanese%20ukiyo-e%20woodblock%20print%20style%2C%20cherry%20blossoms%2C%20mt%20fuji%20in%20background%2C%20bold%20outlines%2C%20flat%20color%20areas%2C%20traditional%20japanese%20art%20aesthetic&width=1024&height=1024&seq=gi2i2&orientation=squarish',
      styleName: '图生图',
      ratio: '1:1',
      prompt: '现代建筑重新想象为日本浮世绘木版画风格，樱花盛开，富士山背景，粗线条，平涂色块',
      createdAt: '2026-05-24',
      isHd: false,
    },
    {
      id: 'gi2i_003',
      imageUrl: 'https://readdy.ai/api/search-image?query=portrait%20transformed%20into%20stained%20glass%20mosaic%20art%20style%2C%20vibrant%20jewel%20tones%2C%20geometric%20fragmented%20shapes%2C%20backlit%20glowing%20effect%2C%20medieval%20cathedral%20aesthetic%2C%20intricate%20details&width=1024&height=1365&seq=gi2i3&orientation=portrait',
      styleName: '图生图',
      ratio: '3:4',
      prompt: '人像转换为彩色玻璃马赛克艺术风格，宝石色调，几何碎片形状，背光发光效果，中世纪大教堂美学',
      createdAt: '2026-05-24',
      isHd: false,
    },
  ],

  generateResultsEdit: [
    {
      id: 'ged_001',
      imageUrl: 'https://readdy.ai/api/search-image?query=young%20woman%20portrait%20with%20added%20golden%20butterfly%20accessories%20in%20hair%2C%20sparkling%20effects%2C%20enhanced%20dreamy%20atmosphere%2C%20soft%20pink%20and%20gold%20color%20grading%2C%20editorial%20beauty%20photography%2C%20high%20end%20retouching&width=1024&height=1365&seq=ged1&orientation=portrait',
      styleName: '修图',
      ratio: '3:4',
      prompt: '在头发上添加金色蝴蝶配饰，闪光特效，增强梦幻氛围，柔粉与金色色调，高级修图质感',
      createdAt: '2026-05-24',
      isHd: false,
    },
    {
      id: 'ged_002',
      imageUrl: 'https://readdy.ai/api/search-image?query=cityscape%20photo%20background%20changed%20to%20aurora%20borealis%20night%20sky%2C%20northern%20lights%20reflection%20on%20water%2C%20enhanced%20colors%2C%20magical%20atmosphere%2C%20professional%20photo%20manipulation%2C%20seamless%20blending&width=1024&height=1024&seq=ged2&orientation=squarish',
      styleName: '修图',
      ratio: '1:1',
      prompt: '将背景替换为极光夜空，北极光倒映在水面，增强色彩，魔幻氛围，专业照片合成，无缝融合',
      createdAt: '2026-05-24',
      isHd: false,
    },
    {
      id: 'ged_003',
      imageUrl: 'https://readdy.ai/api/search-image?query=portrait%20with%20removed%20background%20replaced%20by%20floating%20cherry%20blossom%20petals%2C%20studio%20lighting%20preserved%2C%20clean%20extraction%2C%20spring%20atmosphere%2C%20professional%20photo%20editing%2C%20high%20quality&width=1024&height=1365&seq=ged3&orientation=portrait',
      styleName: '修图',
      ratio: '3:4',
      prompt: '移除背景替换为飘落樱花花瓣，保留影棚布光，干净抠图，春日氛围，专业照片编辑',
      createdAt: '2026-05-24',
      isHd: false,
    },
  ],

  generateResultsRestore: [
    {
      id: 'grs_001',
      imageUrl: 'https://readdy.ai/api/search-image?query=beautiful%20high%20resolution%20portrait%20of%20young%20woman%2C%20crystal%20clear%20sharp%20details%2C%20perfect%20skin%20texture%2C%20vibrant%20eye%20color%2C%20professional%208K%20quality%20photography%2C%20studio%20lighting%2C%20flawless%20restoration%20result&width=1024&height=1365&seq=grs1&orientation=portrait',
      styleName: '画质修复',
      ratio: '3:4',
      prompt: '画质修复结果：晶莹剔透的清晰细节，完美肌肤纹理，鲜明眼神，专业8K品质摄影',
      createdAt: '2026-05-24',
      isHd: true,
    },
    {
      id: 'grs_002',
      imageUrl: 'https://readdy.ai/api/search-image?query=ultra%20sharp%20landscape%20photograph%20of%20mountain%20lake%2C%20crystal%20clear%20water%20reflection%2C%20enhanced%20dynamic%20range%2C%20vivid%20colors%2C%20every%20leaf%20and%20rock%20visible%2C%20HDR%20quality%2C%20professional%20restoration&width=1024&height=1024&seq=grs2&orientation=squarish',
      styleName: '画质修复',
      ratio: '1:1',
      prompt: '风景画质修复：山峰湖泊超清影像，水面倒影晶莹剔透，增强动态范围，每片树叶和岩石清晰可见',
      createdAt: '2026-05-24',
      isHd: true,
    },
    {
      id: 'grs_003',
      imageUrl: 'https://readdy.ai/api/search-image?query=restored%20vintage%20family%20photograph%2C%20colorized%20and%20enhanced%2C%20sharp%20facial%20details%2C%20warm%20nostalgic%20tones%2C%20old%20photo%20restoration%20result%2C%20professional%20photo%20recovery%2C%20memories%20preserved%20in%20high%20quality&width=1024&height=1365&seq=grs3&orientation=portrait',
      styleName: '画质修复',
      ratio: '3:4',
      prompt: '老照片修复：上色增强，清晰面部细节，温暖怀旧色调，专业照片恢复，珍贵记忆高清重现',
      createdAt: '2026-05-24',
      isHd: true,
    },
  ],

  generateResultsTryon: [
    {
      id: 'gto_001',
      imageUrl: 'https://readdy.ai/api/search-image?query=full%20body%20fashion%20photo%20of%20elegant%20young%20woman%20wearing%20flowing%20red%20evening%20gown%2C%20luxury%20fashion%20photography%2C%20professional%20studio%20lighting%2C%20confident%20pose%2C%20high%20end%20fashion%20editorial%20style%2C%20clean%20white%20background&width=1024&height=1820&seq=gto1&orientation=portrait',
      styleName: '虚拟试衣',
      ratio: '9:16',
      prompt: '虚拟试衣结果：优雅年轻女性身着飘逸红色晚礼服，高级时尚摄影，专业影棚布光，自信姿态',
      createdAt: '2026-05-24',
      isHd: false,
    },
    {
      id: 'gto_002',
      imageUrl: 'https://readdy.ai/api/search-image?query=full%20body%20photo%20of%20stylish%20young%20man%20in%20navy%20blue%20business%20suit%2C%20modern%20tailored%20fit%2C%20professional%20corporate%20portrait%2C%20clean%20studio%20background%2C%20confident%20professional%20stance%2C%20high%20quality%20fashion%20photography&width=1024&height=1820&seq=gto2&orientation=portrait',
      styleName: '虚拟试衣',
      ratio: '9:16',
      prompt: '虚拟试衣结果：时尚年轻男性身着藏青色商务西装，现代修身剪裁，专业企业肖像，自信站姿',
      createdAt: '2026-05-24',
      isHd: false,
    },
    {
      id: 'gto_003',
      imageUrl: 'https://readdy.ai/api/search-image?query=full%20body%20fashion%20photo%20of%20trendy%20teenager%20wearing%20oversized%20streetwear%20hoodie%20and%20cargo%20pants%2C%20urban%20style%2C%20dynamic%20pose%2C%20modern%20street%20fashion%20photography%2C%20gradient%20studio%20background%2C%20youthful%20energy&width=1024&height=1820&seq=gto3&orientation=portrait',
      styleName: '虚拟试衣',
      ratio: '9:16',
      prompt: '虚拟试衣结果：潮流青少年身着oversize街头风连帽衫和工装裤，动感姿态，现代街头时尚摄影',
      createdAt: '2026-05-24',
      isHd: false,
    },
  ],

  historyRecords: [
    {
      id: 'h_001',
      imageUrl: 'https://readdy.ai/api/search-image?query=beautiful%20young%20asian%20woman%20portrait%2C%20soft%20natural%20lighting%2C%20elegant%20fashion%20photography%2C%20warm%20tones%2C%20professional%20studio%20quality%2C%20dreamy%20bokeh%20background&width=400&height=533&seq=hist1&orientation=portrait',
      prompt: '一位美丽的年轻女性，精致妆容，柔和自然光，时尚写真风格，高清细节',
      styleId: 's_film',
      styleName: '胶片风',
      ratio: '3:4',
      createdAt: '2026-04-23 14:32',
      pointsCost: 2,
    },
    {
      id: 'h_002',
      imageUrl: 'https://readdy.ai/api/search-image?query=cute%20anime%20girl%20character%20illustration%2C%20big%20sparkling%20eyes%2C%20pastel%20pink%20and%20blue%20colors%2C%20kawaii%20style%2C%20digital%20art%2C%20high%20quality&width=400&height=400&seq=hist2&orientation=squarish',
      prompt: '可爱动漫风格头像，大眼睛，精致五官，清新配色，二次元风格',
      styleId: 's_3d_cartoon',
      styleName: '3D 卡通',
      ratio: '1:1',
      createdAt: '2026-04-23 11:15',
      pointsCost: 2,
    },
    {
      id: 'h_003',
      imageUrl: 'https://readdy.ai/api/search-image?query=chinese%20woman%20in%20traditional%20hanfu%20dress%2C%20ancient%20chinese%20style%20portrait%2C%20ink%20wash%20painting%20background%2C%20elegant%20pose%2C%20soft%20lighting&width=400&height=533&seq=hist3&orientation=portrait',
      prompt: '古风汉服美女，精致妆容，水墨背景，国风意境，高清写真',
      styleId: 's_chinese',
      styleName: '国风',
      ratio: '3:4',
      createdAt: '2026-04-22 20:08',
      pointsCost: 2,
    },
    {
      id: 'h_004',
      imageUrl: 'https://readdy.ai/api/search-image?query=modern%20creative%20poster%20design%2C%20gradient%20pink%20and%20purple%20background%2C%20minimalist%20typography%2C%20professional%20graphic%20design%2C%20vibrant%20colors&width=400&height=711&seq=hist4&orientation=portrait',
      prompt: '创意海报设计，现代简约风格，渐变背景，精美排版，视觉冲击力强',
      styleId: 's_comic',
      styleName: '漫画',
      ratio: '9:16',
      createdAt: '2026-04-22 16:44',
      pointsCost: 2,
    },
    {
      id: 'h_005',
      imageUrl: 'https://readdy.ai/api/search-image?query=handsome%20young%20asian%20man%20portrait%20photography%2C%20clean%20background%2C%20professional%20studio%20lighting%2C%20confident%20pose%2C%20high%20quality%20fashion%20photo&width=400&height=533&seq=hist5&orientation=portrait',
      prompt: '一位帅气的年轻男性，干净利落，自然光线，时尚写真风格，高清细节',
      styleId: 's_ccd',
      styleName: 'CCD 相机',
      ratio: '3:4',
      createdAt: '2026-04-21 09:20',
      pointsCost: 2,
    },
    {
      id: 'h_006',
      imageUrl: 'https://readdy.ai/api/search-image?query=fantasy%20landscape%20with%20cherry%20blossom%20trees%2C%20soft%20pink%20petals%20falling%2C%20dreamy%20atmosphere%2C%20watercolor%20painting%20style%2C%20pastel%20colors&width=400&height=300&seq=hist6&orientation=landscape',
      prompt: '梦幻樱花林，花瓣飘落，柔和粉色光晕，水彩画风格，唯美意境',
      styleId: 's_film',
      styleName: '胶片风',
      ratio: '4:3',
      createdAt: '2026-04-20 21:55',
      pointsCost: 2,
    },
  ],

  showcase: [
    {
      id: 1,
      src: 'https://readdy.ai/api/search-image?query=beautiful%20AI%20generated%20portrait%20of%20young%20asian%20woman%2C%20soft%20pink%20tones%2C%20professional%20photography%20style%2C%20elegant%20and%20artistic&width=200&height=260&seq=show1&orientation=portrait',
      label: 'CCD 相机',
      size: 'tall',
    },
    {
      id: 2,
      src: 'https://readdy.ai/api/search-image?query=cute%20anime%20girl%20illustration%2C%20pastel%20colors%2C%20kawaii%20style%2C%20big%20eyes%2C%20colorful%20background%2C%20digital%20art&width=200&height=200&seq=show2&orientation=squarish',
      label: '动漫头像',
      size: 'normal',
    },
    {
      id: 3,
      src: 'https://readdy.ai/api/search-image?query=traditional%20chinese%20hanfu%20woman%20portrait%2C%20ancient%20style%2C%20ink%20painting%20background%2C%20elegant%20pose%2C%20artistic%20photography&width=200&height=200&seq=show3&orientation=squarish',
      label: '国风人像',
      size: 'normal',
    },
    {
      id: 4,
      src: 'https://readdy.ai/api/search-image?query=3D%20cartoon%20character%20render%2C%20cute%20chibi%20style%2C%20bright%20colors%2C%20pixar%20style%2C%20clean%20white%20background&width=200&height=260&seq=show4&orientation=portrait',
      label: '3D 卡通',
      size: 'tall',
    },
    {
      id: 5,
      src: 'https://readdy.ai/api/search-image?query=film%20photography%20style%20portrait%2C%20light%20leak%20effect%2C%20vintage%20grain%2C%20warm%20nostalgic%20tones%2C%20young%20woman&width=200&height=200&seq=show5&orientation=squarish',
      label: '胶片风',
      size: 'normal',
    },
    {
      id: 6,
      src: 'https://readdy.ai/api/search-image?query=modern%20creative%20poster%20design%2C%20gradient%20pink%20purple%20background%2C%20typography%2C%20minimalist%20style%2C%20professional%20graphic%20design&width=200&height=200&seq=show6&orientation=squarish',
      label: '海报封面',
      size: 'normal',
    },
  ],

  inspirationHints: [
    { icon: 'ri-user-smile-line', text: '女生写真', sub: '精致妆容·柔和光线', color: '#FF6B9D' },
    { icon: 'ri-landscape-line', text: '国风人像', sub: '汉服·水墨意境', color: '#A855F7' },
    { icon: 'ri-gamepad-line', text: '动漫头像', sub: '二次元·可爱风', color: '#EC4899' },
    { icon: 'ri-image-2-line', text: '创意海报', sub: '渐变·视觉冲击', color: '#8B5CF6' },
  ],

  membership: {
    benefits: [
      { icon: 'ri-image-2-line', title: '高清无水印下载', desc: '生成图片高清无水印，随时保存' },
      { icon: 'ri-flashlight-line', title: '更多生成次数', desc: '每月大额积分赠送，畅快创作' },
      { icon: 'ri-palette-line', title: '解锁高级风格', desc: '敦煌壁画等专属风格任意使用' },
      { icon: 'ri-rocket-line', title: '生成加速', desc: '优先队列，更快出图' },
    ],
    packages: [
      {
        id: 'single',
        name: '单次包',
        price: 6,
        originalPrice: 10,
        desc: '一次性购买，永久有效',
        tag: '',
        isRecommended: false,
        pointsGift: 20,
        validDays: null,
        benefits: [
          { icon: 'ri-image-line', title: '20积分', desc: '可生成 10 张图片' },
          { icon: 'ri-download-line', title: '标清下载', desc: '图片标清无水印下载' },
          { icon: 'ri-palette-line', title: '基础风格', desc: '使用全部免费风格' },
          { icon: 'ri-time-line', title: '永久有效', desc: '积分永不过期' },
        ],
      },
      {
        id: 'monthly_auto',
        name: '连续包月',
        price: 28,
        originalPrice: 48,
        desc: '自动续费，随时取消',
        tag: '推荐',
        isRecommended: true,
        pointsGift: 200,
        validDays: 30,
        benefits: [
          { icon: 'ri-image-2-line', title: '高清无水印', desc: '生成图片高清无水印下载' },
          { icon: 'ri-flashlight-line', title: '首次赠送200积分', desc: '首次开通即赠' },
          { icon: 'ri-palette-line', title: '解锁高级风格', desc: '敦煌壁画等专属风格' },
          { icon: 'ri-rocket-line', title: '优先生成', desc: '优先队列，更快出图' },
        ],
      },
      {
        id: 'monthly',
        name: '月卡',
        price: 38,
        originalPrice: 48,
        desc: '一次性购买，30天有效',
        tag: '',
        isRecommended: false,
        pointsGift: 150,
        validDays: 30,
        benefits: [
          { icon: 'ri-image-2-line', title: '高清无水印', desc: '生成图片高清无水印下载' },
          { icon: 'ri-flashlight-line', title: '150积分', desc: '一次性赠送积分' },
          { icon: 'ri-palette-line', title: '解锁高级风格', desc: '敦煌壁画等专属风格' },
          { icon: 'ri-rocket-line', title: '优先生成', desc: '优先队列，更快出图' },
        ],
      },
      {
        id: 'quarterly',
        name: '季卡',
        price: 88,
        originalPrice: 144,
        desc: '一次性购买，90天有效',
        tag: '超值',
        isRecommended: false,
        pointsGift: 500,
        validDays: 90,
        benefits: [
          { icon: 'ri-image-2-line', title: '高清无水印', desc: '生成图片高清无水印下载' },
          { icon: 'ri-flashlight-line', title: '500积分', desc: '季度赠送超大额积分' },
          { icon: 'ri-palette-line', title: '全部风格', desc: '解锁全部专属风格' },
          { icon: 'ri-vip-crown-line', title: '专属客服', desc: '季卡用户专属客服通道' },
        ],
      },
      {
        id: 'yearly',
        name: '年卡',
        price: 298,
        originalPrice: 576,
        desc: '一次性购买，365天有效',
        tag: '最划算',
        isRecommended: false,
        pointsGift: 2400,
        validDays: 365,
        benefits: [
          { icon: 'ri-image-2-line', title: '高清无水印', desc: '生成图片高清无水印下载' },
          { icon: 'ri-flashlight-line', title: '2400积分', desc: '全年超大额积分赠送' },
          { icon: 'ri-palette-line', title: '全部风格', desc: '解锁全部专属风格' },
          { icon: 'ri-vip-crown-2-line', title: '至尊权益', desc: '专属客服+优先体验新功能' },
        ],
      },
    ],
  },

  customerService: {
    email: 'paidaxing1121@gmail.com',
    phone: '400-888-6688',
    workTime: '周一至周五 10:00 - 18:00',
  },

  agreements: {
    userAgreement: {
      title: '用户协议',
      updateDate: '2026年1月1日',
      effectiveDate: '2026年1月1日',
      sections: [
        { title: '一、服务说明', content: 'NanoImage2 是一款 AI 图片生成工具，用户通过输入文字描述生成图片内容。' },
        { title: '二、用户行为规范', content: '用户不得利用本服务生成违法、违规、侵权内容。生成的图片仅供个人使用，不得用于商业用途（VIP 用户除外）。' },
        { title: '三、积分与会员', content: '积分为虚拟权益，不可提现。会员订阅到期后自动失效，连续包月可随时取消。' },
        { title: '四、免责声明', content: 'AI 生成内容由模型自动产生，平台不对生成结果的准确性、完整性作出保证。' },
      ],
    },
    privacyPolicy: {
      title: '隐私政策',
      updateDate: '2026年1月1日',
      effectiveDate: '2026年1月1日',
      sections: [
        { title: '一、信息收集', content: '我们收集您的手机号用于账号注册与登录，收集您的生成记录用于历史查看功能。' },
        { title: '二、信息使用', content: '您的个人信息仅用于提供服务，不会出售给第三方。我们可能使用匿名化数据改善 AI 模型效果。' },
        { title: '三、数据安全', content: '我们采用加密传输和存储技术保护您的数据安全，定期进行安全审计。' },
        { title: '四、您的权利', content: '您可以随时申请删除账号及相关数据，请联系客服处理。' },
      ],
    },
    memberAgreement: {
      title: '会员服务协议',
      updateDate: '2026年1月1日',
      effectiveDate: '2026年1月1日',
      sections: [
        { title: '一、会员服务内容', content: 'NanoImage2 会员服务是由 NanoImage2 提供的付费增值服务。开通会员后，您可享受高清无水印图片下载、每月大额积分赠送、解锁全部高级风格模板、AI 生图优先队列等专属权益。' },
        { title: '二、会员费用与有效期', content: '连续包月套餐：¥28/月，到期自动续费，可随时取消。月卡套餐：¥38/月，一次性购买，30天有效，到期不自动续费。' },
        { title: '三、退款政策', content: '会员服务为虚拟数字商品，一经开通不支持退款。如因平台原因导致服务不可用，将按实际不可用天数折算退款。' },
        { title: '四、账号与权益', content: '会员权益与账号绑定，不可转让。账号注销后，剩余会员权益将同步清除，不予补偿。' },
        { title: '五、协议变更', content: 'NanoImage2 有权根据业务需要修改本协议，修改后将在 App 内公告，继续使用即视为同意修改后的协议。' },
      ],
    },
    autoRenewAgreement: {
      title: '自动续费协议',
      updateDate: '2026年1月1日',
      effectiveDate: '2026年1月1日',
      sections: [
        { title: '一、自动续费说明', content: '本协议仅适用于选择「连续包月」套餐的用户。开通后，系统将在每个计费周期到期前 24 小时内自动从您绑定的支付账户扣款，扣款成功后自动续期 30 天。' },
        { title: '二、续费金额', content: '自动续费金额为 ¥28/月。如遇价格调整，将提前 7 天通过 App 通知告知，您可在通知后选择取消续费。' },
        { title: '三、取消自动续费', content: '您可随时在「个人中心 - 会员中心 - 管理订阅」中关闭自动续费。取消后，当前计费周期内的会员权益仍可正常使用，到期后不再续费。' },
        { title: '四、扣款失败处理', content: '若自动续费扣款失败（如余额不足），系统将在 3 天内重试扣款。重试期间会员权益正常使用。超过重试期仍未成功，会员权益将暂停，补缴后可恢复。' },
        { title: '五、注意事项', content: '请确保绑定的支付账户余额充足；自动续费扣款前会发送通知提醒；如有疑问请联系客服处理。' },
      ],
    },
  },
};

export const mockUser = appConfig.user;
export const mockTemplates = appConfig.templates;
export const mockStyles = appConfig.styles;
export const mockRatios = appConfig.ratios;
export const mockGenerateResults = appConfig.generateResults;
export const mockGenerateResultsText2Img = appConfig.generateResultsText2Img;
export const mockGenerateResultsImg2Img = appConfig.generateResultsImg2Img;
export const mockGenerateResultsEdit = appConfig.generateResultsEdit;
export const mockGenerateResultsRestore = appConfig.generateResultsRestore;
export const mockGenerateResultsTryon = appConfig.generateResultsTryon;
export const mockAIHelpWrite = appConfig.aiHelpPrompts;
export const mockHistoryRecords = appConfig.historyRecords;
export const mockPointsLog = appConfig.pointsLog;
export const mockShowcase = appConfig.showcase;
export const mockInspirationHints = appConfig.inspirationHints;
export const mockMembership = appConfig.membership;
export const mockCustomerService = appConfig.customerService;
export const mockAgreements = appConfig.agreements;
